<template>
    <!-- 落布标签详情弹框，目前只显示工人信息 -->
    <el-dialog :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false" id="pageDetail">
        <el-button type="primary" @click="initPrint('pageDetail')" size="mini" icon="el-icon-printer">打印
        </el-button>

        <span slot="title">落布详情</span>
        <el-table :data="labelData.productWorkers" :header-cell-style="{'text-align':'center'}"
            :cell-style="{'padding':'0px'}" border stripe max-height="400">
            <el-table-column v-for="(value,key) in workerKeys" :key="key" :label="value" :prop="key" align="center" />
        </el-table>

        <!-- 二维码图片 -->
        <br />
        <div style="display: flex; justify-content: center; ">
            <div style="display: flex; flex-direction: column;  ">
                <div id="qrCodeUrl"></div>
                <br />
                <span>落布标签编号 = {{labelData.productLableNumber}}</span>
            </div>
        </div>


    </el-dialog>
</template>

<script>
    import QRCode from 'qrcodejs2' //二维码生成

    export default {
        data() {
            return {
                dialogVisible: false,
                labelData: [],
                workerKeys: {
                    name: '工人姓名',
                    length: '工人生产长度(米)',
                    upWight: '工人生产重量(千克)'
                }
            }
        },
        methods: {
            // 外部调用，显示落布标签详情弹框
            show(labelData) {
                this.labelData = this.formatLabelData(labelData)
                this.qrCodeGeneration() //二维码生成

                this.dialogVisible = true
            },
            // 格式化落布标签详情
            formatLabelData(labelData) {
				let labeldata = {productWorkers:[]}
				for(let i=0; i<labelData.productWorkers.length; i++){
					let data = {
						name:labelData.productWorkers[i].name,
						length:(Number(labelData.productWorkers[i].length)/100).toFixed(2),
						upWight:(Number(labelData.productWorkers[i].upWight)/1000).toFixed(2),
					}
					labeldata.productWorkers.push(data)
					
				}
				labeldata.productLableNumber = labelData.productLableNumber
                return labeldata
            },
            // 二维码生成
            qrCodeGeneration() {
                // 生成二维码
                this.$nextTick(function() {
                    document.getElementById("qrCodeUrl").innerHTML = "";
                    let qrCodeUrl = new QRCode("qrCodeUrl", {
                        width: 200,
                        height: 200,
                        text: this.labelData.productLableNumber, //二维码 显示的内容
                        colorDark: "#409EFF",
                        colorLight: "#fff"
                    });
                });
            },
            
            // 在打印当前报表前，拼接title
            initPrint(id) {
                this.utils.printTable(id, `落布详情`)
            },
        },
        mounted() {}
    }
</script>

<style scoped>
</style>
